import { useCreate } from "../../../../api/react-query"

export function useCreateConfigTypes({ params = {} }) {
    const {
        mutateAsync: createConfigType,
        isLoading: isCreating,
        error
    } = useCreate({
        url: 'config/type',
        params: params,
        apiVersion: 'v1',
        msg: params?.message ?? 'Created Successfully'
    })

    return {
        createConfigType,
        isCreating,
        error
    }
}
